import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import useAgentMemory from '../../../hooks/useAgentMemory';
import MemoryFactRow from '../components/MemoryFactRow';
import DataModeBadge from '../../../components/feedback/DataModeBadge';
import { formatDistanceToNow } from 'date-fns';

function MemoryTab({ agent }) {
  const { facts, setFacts, stats, isLoading, mode } = useAgentMemory(agent.id);
  const [draft, setDraft] = useState('');

  const addFact = (event) => {
    event.preventDefault();
    const text = draft.trim();

    if (!text) {
      return;
    }

    setFacts((previous) => [
      { id: `fact-local-${Date.now()}`, text, pinned: false, updatedAt: new Date().toISOString() },
      ...previous
    ]);
    setDraft('');
  };

  const togglePin = (factId) => {
    setFacts((previous) => previous.map((fact) => (
      fact.id === factId ? { ...fact, pinned: !fact.pinned } : fact
    )));
  };

  const removeFact = (factId) => {
    setFacts((previous) => previous.filter((fact) => fact.id !== factId));
  };

  if (isLoading) {
    return <p className="tab-empty">Loading memory…</p>;
  }

  return (
    <div className="tab-panel-grid">
      <section className="tab-section">
        <header className="section-heading">
          <div>
            <h3>
              Memory facts <DataModeBadge mode={mode} />
            </h3>
            <span>{facts.length} entries · edits are local until the API lands</span>
          </div>
        </header>
        <form className="fact-composer" onSubmit={addFact}>
          <input
            onChange={(event) => setDraft(event.target.value)}
            placeholder="Teach the agent a new fact…"
            type="text"
            value={draft}
          />
          <button className="primary-button" type="submit">
            <FiPlus /> Add fact
          </button>
        </form>
        <ul className="memory-fact-list">
          {facts.map((fact) => (
            <MemoryFactRow
              fact={fact}
              key={fact.id}
              onDelete={removeFact}
              onTogglePin={togglePin}
            />
          ))}
        </ul>
      </section>
      <aside className="side-stack">
        {stats && (
          <div className="stat-card">
            <span>Vector index</span>
            <strong>{stats.indexHealth}</strong>
            <em>
              Indexed {formatDistanceToNow(new Date(stats.lastIndexedAt), { addSuffix: true })}
            </em>
          </div>
        )}
        {stats && (
          <div className="stat-card">
            <span>Stored chunks</span>
            <strong>{stats.chunks.toLocaleString()}</strong>
            <em>{stats.dimensions}-dim embeddings</em>
          </div>
        )}
      </aside>
    </div>
  );
}

export default MemoryTab;
